
import angular from "angular";
import uiRouterModule  from "@uirouter/angularjs";

import Assert from "tbAssert";
import DependencyListBuilder from "../../utility/DependencyListBuilder";

import TrackingEventEditorModuleConstants from "./Constants";

import TrackingEventEditorController from "./TrackingEventEditorController";

function TrackingEventEditorConfiguration($stateProvider, $urlRouterProvider) {

    Assert.StrictAssert($stateProvider != null, "Assertion Failure: Missing UI Router State Provider Dependency");
    Assert.StrictAssert($urlRouterProvider != null, "Assertion Failure: Missing UI Router Url Router Provider Dependency");

    $stateProvider.state(TrackingEventEditorModuleConstants.rootStateName, {
        url: "/tracking-event/{eventId:int}",
        template: TrackingEventEditorController.template,
        controller: TrackingEventEditorController,
        controllerAs: TrackingEventEditorController.controllerAs,
        data: {
            requiresLogin: true
        }
    });

    $urlRouterProvider.when("/tracking-event", "/tracking-calendar");
}

TrackingEventEditorConfiguration.$inject = [ "$stateProvider", "$urlRouterProvider" ];

TrackingEventEditorConfiguration.dependencies = [ uiRouterModule ];

const trackingEventEditorModuleDependencies = DependencyListBuilder([
    TrackingEventEditorConfiguration.dependencies,
    TrackingEventEditorController.dependencies
]);

export default angular
    .module(
        "trackerbase-app.views.tracking-event-editor",
        trackingEventEditorModuleDependencies
    )
    .config(TrackingEventEditorConfiguration)
    .name;



//////////////////
// WEBPACK FOOTER
// ./src/views/tracking-event-editor/TrackingEventEditor.js
// module id = VVs7
// module chunks = 1